<template>
    <div class="main-container">
        <div class="filter-container">
            <el-input class="filter-item" v-model="filters.second_brand_name" placeholder="二级品牌" style="width:170px" clearable></el-input>
            <el-input class="filter-item" v-model="filters.title" placeholder="商品名称" style="width:170px" clearable></el-input>
            <el-select class="filter-item" v-model="filters.check_status" placeholder="审核状态" style="width:170px" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="未提交" value="0"></el-option>
                <el-option label="审核中" value="1"></el-option>
                <el-option label="审核通过" value="2"></el-option>
                <el-option label="驳回" value="3"></el-option>
            </el-select>
            <el-date-picker class="filter-item" v-model="filters.start_date" type="date" placeholder="制单开始日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <span class="filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" type="date" placeholder="制单开始日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <el-input class="filter-item" v-model="filters.username" placeholder="制单人" style="width:170px" clearable></el-input>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
        </div>

        <el-table :data="tableData" border :empty-text="emptyStr" style="width:100%">
            <el-table-column type="index" :index="tableIndex"></el-table-column>
            <el-table-column prop="second_brand_name" label="二级品牌"></el-table-column>
            <el-table-column prop="title" label="商品"></el-table-column>
            <el-table-column prop="buy_count" label="销量" ></el-table-column>
            <el-table-column prop="market_price" label="市场价"></el-table-column>
            <el-table-column prop="price" label="售价" ></el-table-column>
            <!-- 定时上架商品，审核通过后状态为“定时审核，待执行”，当过了定时上架时间显示“审核通过” -->
            <el-table-column prop="check_status" label="审核状态">
                <template #default="scope">
                    <span>{{ CheckStatus[scope.row.check_status]==='审核通过' ? scope.row.is_time && (new Date().getTime() < new Date(scope.row.examine_time).getTime()) ? '定时审核，待执行' : '审核通过' : CheckStatus[scope.row.check_status] }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="admin_name" label="制单人"></el-table-column>
            <el-table-column prop="preparation_time" label="制单时间" width="160"></el-table-column>
            <el-table-column label="操作" width="150">
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary" size="small" @click="toEdit(scope.row, 'view')">查看</el-button>
                        <!-- <el-button type="primary" size="small" :disabled="scope.row.check_status===CheckStatus['审核中'] || scope.row.check_status===CheckStatus['审核通过']" @click="toEdit(scope.row, 'edit')">编辑</el-button> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="onPageChange"
            :currentPage="filters.page"
            :page-size="filters.limit"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import {useRouter} from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated } from 'vue'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'
import { CheckStatus } from '@/enums/product'
export default defineComponent({
name: 'VoucherList',
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()

    const state = reactive({
        filters: {
            second_brand_name:  '',     // 二级品牌名称
            title:              '',     // 商品名称
            check_status:       '',     // 审核状态
            username:           '',     // 制单人
            start_date:         '',     // 搜索开始日期
            end_date:           '',     // 搜索结束日期
            page:               1,      // 当前页码
            limit:              10,     // 每页显示条数
        },
        total:  0,  // 总条数
        file: {}, // 上传文件信息
        check_coupon:'',
        tableData: [],
        emptyStr:'暂无数据',
        chargeOffData:[],
        count: 0,
        dialogBatchChangePrice: false,
        check_status:0,

        // 表格 index 连续
        tableIndex: (index) => {
            const { page, limit } = state.filters
            return (page - 1) * limit + index + 1
        },
        handleSizeChange(val){
            state.filters.pageSizes = val
            state.getList();
        },
        onPageChange(val) {
            state.filters.page = val
            state.getList();
        },
        getList(){
            proxy.$http.get(`/admin/shop_product/getShopProductCheckList?${joinParams(state.filters)}`).then(res => {
                if(res.code == 200){
                    state.tableData = res.data || []
                    state.total = res.count || 0
                }else{
                    state.tableData = []
                    state.emptyStr = res.msg
                }
            })
        },
        search(){
            state.filters.page = 1
            state.getList();
        },
        toEdit: (row, t) => {
            router.push(`/merchant-admin/product-edit-old?id=${row.id}&t=${t}&check_type=1`) // check_type=1 表示是由商户端审核列表进入
        }
    })

    state.getList()
    onActivated(() => {
        state.getList()
    })
    return { ...toRefs(state),  Keys, store, CheckStatus }
}
})
</script>